import React from "react";
import { Image, Text, View, Page, Document, StyleSheet, Rect } from '@react-pdf/renderer';
import { Fragment } from "react";
import { Font } from "@react-pdf/renderer";
import IRANSans from '../../../fonts/IRANSans.ttf';
import headerLogo from '../../../Images/headerLogo.png';
Font.register({ family: "IRANSans", src: IRANSans });

const styles = StyleSheet.create({
    page: {paddingTop: 20,paddingLeft: 40,paddingRight: 40,lineHeight: 1.5,flexDirection: 'column', fontFamily:'IRANSans', color:'black' },
    
    logo: { width: 100, alignItems:'center', display:'block', marginLeft:'auto', marginRight:'auto' },

    firstBorder:{borderWidth: 1, height: '300'},

    secondBorder:{ flex:1, borderWidth:1, borderColor : 'black', overflow:'hidden', margin:2}
    
});



// const sendAddress = () => (
//     <View style={styles.address}>
//         <text>hiii</text>
//     </View>
// );


const ReceiverAddress = (props) => (
    <View style={styles.firstBorder}>
         
         <PageHead remain= {props.prp.remainMonth} number = {props.prp.number}/>

         <TableBody data = {props.prp} newVersion = {props.newVersion} />               
      
          
    </View>
);



    const PageHead = (props) => (
      <View style={{ width:'100%', flexDirection :'row', direction:'rtl', height:'50%'}}>

            <View style={styles.secondBorder}>          
            <Text style={{direction:'rtl', textAlign: 'right', fontSize: 7, marginTop: 10, marginRight: 5}}>فرستنده: </Text>   
            <Text style={{direction:'rtl', textAlign: 'right', fontSize: 10,fontWeight: 'bold', marginTop: 5, marginRight: 5}}>موسسه فرهنگی موعود عصر</Text>   
            <Text style={{direction:'rtl', textAlign: 'right', fontSize: 7, marginTop: 10, marginRight: 5}}>صندوق پستی: شهر تهران- 8347-14155</Text>   
            <Text style={{direction:'rtl', textAlign: 'right', fontSize: 7, marginTop: 10, marginRight: 5}}>تلفن تماس :02166459347</Text>   
            <Text style={{direction:'rtl', textAlign: 'right', fontSize: 7, marginTop: 10, marginRight: 5}}>Email: info@mouood.org</Text>   
            </View>
        
        <View style={[styles.secondBorder]}>
         
           <Image style={styles.logo} src={headerLogo} />
           <Text  style={{textAlign: 'left', marginLeft: 10, marginTop: 2, fontSize: 11}}>موسسه فرهنگی</Text>
           <Text style={{textAlign: 'right', marginLeft: 1, marginRight: 6,marginBottom: 3,marginTop: 8, fontSize: 9}}>تعداد: {props.number}</Text>
        </View>

            <View style={styles.secondBorder}>          
            <Text style={{direction:'rtl', textAlign: 'right', fontSize: 9, marginRight: 5, marginTop:50}}> {props.remain === 2 ? "توجه: از اشتراک شما تنها یک جلد باقی مانده است" : props.remain === 1 ? "توجه: اشتراک شما تمام شده است": null }</Text>   
            </View>

       
      </View>
    );

    const TableBody = (props) => (
            <Fragment>
               
                <View  style={{ width:'100%', height: '70%'}}>
                    <View style={styles.secondBorder}>
                    <View >
                        <Text style={{direction:'rtl', fontSize: 9, marginTop: 10, marginRight: 20}}>گیرنده: </Text>   
                    </View> <View >
                        <Text style={{direction:'rtl', fontWeight:'bold', fontSize: 11, marginTop: 5, marginRight: 30}}>{props.data.person.city.province.provinceName}-{props.data.person.city.cityName}-{props.data.person.postalCode}</Text>   
                    </View>
                    <View >
                        <Text style={{direction:'rtl', fontSize: 9, marginTop: 10, marginRight: 30}}>{props.data.person.address}</Text>   
                    </View>
                    <View >
                    <Text style={{direction:'rtl', fontWeight:'bold', fontSize: 11, marginTop: 10, marginRight: 30}}>«{props.data.person.firstName}{props.data.person.lastName}»</Text>   
                    </View> 
                    <View >
                       <Text style={{direction:'rtl', fontSize: 9, marginTop: 10, marginRight: 30}}>شماره تماس: {props.data.person.phoneNumber}</Text>   
                    </View>
                    <View >
                       <Text style={{direction:'rtl', fontSize: 9, marginTop: 10, marginRight: 30}}>شماره: {props.newVersion}</Text>   
                    </View>
                </View>
                </View>

            </Fragment>
           
    );


const Pdf_Post = (props)=>
{  
        if(props.printData === undefined)
        {

            return(    
                <Document >
                    <Page  style={styles.page}>   
                        <View>
                            
                           
                                <View style={{marginTop: 30}}>
        
                                   {/* <ReceiverAddress prp = {props.printData} newVersion = {props.newVersion} /> */}
                                </View>
                                   
        
                        </View>
                    
                   
                    </Page>
                </Document>
            )
            
        }else
        {
            return(    
                <Document >
                    <Page  style={styles.page} >   
                        <View>
                            
                            {props.printData.map((prp)=>
                            {
                              return(
                                <View style={{marginTop: 70}}>
        
                                   <ReceiverAddress prp = {prp} newVersion = {props.newVersion} />
                                </View>
                              )
        
        
        
                            })}
        
        
                        </View>
                    
                   
                    </Page>
                </Document>
            )
        }
    
   
}

export default Pdf_Post;
